import { render } from "./ViewPayments.vue?vue&type=template&id=0b98f820"
import script from "./ViewPayments.vue?vue&type=script&lang=js"
export * from "./ViewPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__